module.exports = __webpack_public_path__ + "img/benefits-stack.98a6038f.jpg";